import { menuConfig } from "./menu.config";

export const buildMenu = (userType: string, features: any) => {
  
  const isFeatureEnabled = (featureKey?: string) => {
    if (!featureKey) return true;
    return features?.[featureKey]?.isEnabled ?? false;
  };

  return menuConfig
    .filter(menu => menu.roles.includes(userType))
    .map(menu => {

      if (menu.children) {
        const filteredChildren = menu.children.filter(child =>
          isFeatureEnabled(child.featureKey)
        );

        if (filteredChildren.length === 0) return null;

        return {
          ...menu,
          children: filteredChildren
        };
      }

      return isFeatureEnabled(menu.featureKey) ? menu : null;
    })
    .filter(Boolean);
};